// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"b6d01e64","18":"a8463c30","230":"ec3caa2b","394":"2ca886d8","819":"dc99d696","887":"2fc3025e"}[chunkId] + ".chunk.js";
};